import Ce from "axios";
import { useState as ee, useEffect as te } from "react";
import { useAuth as xe, hasAuthParams as Ae } from "react-oidc-context";
class H extends Error {
}
H.prototype.name = "InvalidTokenError";
function Oe(t) {
  return decodeURIComponent(atob(t).replace(/(.)/g, (e, s) => {
    let i = s.charCodeAt(0).toString(16).toUpperCase();
    return i.length < 2 && (i = "0" + i), "%" + i;
  }));
}
function qe(t) {
  let e = t.replace(/-/g, "+").replace(/_/g, "/");
  switch (e.length % 4) {
    case 0:
      break;
    case 2:
      e += "==";
      break;
    case 3:
      e += "=";
      break;
    default:
      throw new Error("base64 string is not of the correct length");
  }
  try {
    return Oe(e);
  } catch {
    return atob(e);
  }
}
function Me(t, e) {
  if (typeof t != "string")
    throw new H("Invalid token specified: must be a string");
  e || (e = {});
  const s = e.header === !0 ? 0 : 1, i = t.split(".")[s];
  if (typeof i != "string")
    throw new H(`Invalid token specified: missing part #${s + 1}`);
  let r;
  try {
    r = qe(i);
  } catch (n) {
    throw new H(`Invalid token specified: invalid base64 for part #${s + 1} (${n.message})`);
  }
  try {
    return JSON.parse(r);
  } catch (n) {
    throw new H(`Invalid token specified: invalid json for part #${s + 1} (${n.message})`);
  }
}
var Ne = {
  debug: () => {
  },
  info: () => {
  },
  warn: () => {
  },
  error: () => {
  }
}, k, E, J = /* @__PURE__ */ ((t) => (t[t.NONE = 0] = "NONE", t[t.ERROR = 1] = "ERROR", t[t.WARN = 2] = "WARN", t[t.INFO = 3] = "INFO", t[t.DEBUG = 4] = "DEBUG", t))(J || {});
((t) => {
  function e() {
    k = 3, E = Ne;
  }
  t.reset = e;
  function s(r) {
    if (!(0 <= r && r <= 4))
      throw new Error("Invalid log level");
    k = r;
  }
  t.setLevel = s;
  function i(r) {
    E = r;
  }
  t.setLogger = i;
})(J || (J = {}));
var g = class b {
  constructor(e) {
    this._name = e;
  }
  /* eslint-disable @typescript-eslint/no-unsafe-enum-comparison */
  debug(...e) {
    k >= 4 && E.debug(b._format(this._name, this._method), ...e);
  }
  info(...e) {
    k >= 3 && E.info(b._format(this._name, this._method), ...e);
  }
  warn(...e) {
    k >= 2 && E.warn(b._format(this._name, this._method), ...e);
  }
  error(...e) {
    k >= 1 && E.error(b._format(this._name, this._method), ...e);
  }
  /* eslint-enable @typescript-eslint/no-unsafe-enum-comparison */
  throw(e) {
    throw this.error(e), e;
  }
  create(e) {
    const s = Object.create(this);
    return s._method = e, s.debug("begin"), s;
  }
  static createStatic(e, s) {
    const i = new b(`${e}.${s}`);
    return i.debug("begin"), i;
  }
  static _format(e, s) {
    const i = `[${e}]`;
    return s ? `${i} ${s}:` : i;
  }
  /* eslint-disable @typescript-eslint/no-unsafe-enum-comparison */
  // helpers for static class methods
  static debug(e, ...s) {
    k >= 4 && E.debug(b._format(e), ...s);
  }
  static info(e, ...s) {
    k >= 3 && E.info(b._format(e), ...s);
  }
  static warn(e, ...s) {
    k >= 2 && E.warn(b._format(e), ...s);
  }
  static error(e, ...s) {
    k >= 1 && E.error(b._format(e), ...s);
  }
  /* eslint-enable @typescript-eslint/no-unsafe-enum-comparison */
};
J.reset();
var j = class {
  // IMPORTANT: doesn't validate the token
  static decode(t) {
    try {
      return Me(t);
    } catch (e) {
      throw g.error("JwtUtils.decode", e), e;
    }
  }
  static async generateSignedJwt(t, e, s) {
    const i = p.encodeBase64Url(new TextEncoder().encode(JSON.stringify(t))), r = p.encodeBase64Url(new TextEncoder().encode(JSON.stringify(e))), n = `${i}.${r}`, o = await window.crypto.subtle.sign(
      {
        name: "ECDSA",
        hash: { name: "SHA-256" }
      },
      s,
      new TextEncoder().encode(n)
    ), a = p.encodeBase64Url(new Uint8Array(o));
    return `${n}.${a}`;
  }
  static async generateSignedJwtWithHmac(t, e, s) {
    const i = p.encodeBase64Url(new TextEncoder().encode(JSON.stringify(t))), r = p.encodeBase64Url(new TextEncoder().encode(JSON.stringify(e))), n = `${i}.${r}`, o = await window.crypto.subtle.sign(
      "HMAC",
      s,
      new TextEncoder().encode(n)
    ), a = p.encodeBase64Url(new Uint8Array(o));
    return `${n}.${a}`;
  }
}, He = "10000000-1000-4000-8000-100000000000", K = (t) => btoa([...new Uint8Array(t)].map((e) => String.fromCharCode(e)).join("")), ae = class S {
  static _randomWord() {
    const e = new Uint32Array(1);
    return crypto.getRandomValues(e), e[0];
  }
  /**
   * Generates RFC4122 version 4 guid
   */
  static generateUUIDv4() {
    return He.replace(
      /[018]/g,
      (s) => (+s ^ S._randomWord() & 15 >> +s / 4).toString(16)
    ).replace(/-/g, "");
  }
  /**
   * PKCE: Generate a code verifier
   */
  static generateCodeVerifier() {
    return S.generateUUIDv4() + S.generateUUIDv4() + S.generateUUIDv4();
  }
  /**
   * PKCE: Generate a code challenge
   */
  static async generateCodeChallenge(e) {
    if (!crypto.subtle)
      throw new Error("Crypto.subtle is available only in secure contexts (HTTPS).");
    try {
      const i = new TextEncoder().encode(e), r = await crypto.subtle.digest("SHA-256", i);
      return K(r).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
    } catch (s) {
      throw g.error("CryptoUtils.generateCodeChallenge", s), s;
    }
  }
  /**
   * Generates a base64-encoded string for a basic auth header
   */
  static generateBasicAuth(e, s) {
    const r = new TextEncoder().encode([e, s].join(":"));
    return K(r);
  }
  /**
   * Generates a hash of a string using a given algorithm
   * @param alg
   * @param message
   */
  static async hash(e, s) {
    const i = new TextEncoder().encode(s), r = await crypto.subtle.digest(e, i);
    return new Uint8Array(r);
  }
  /**
   * Generates a rfc7638 compliant jwk thumbprint
   * @param jwk
   */
  static async customCalculateJwkThumbprint(e) {
    let s;
    switch (e.kty) {
      case "RSA":
        s = {
          e: e.e,
          kty: e.kty,
          n: e.n
        };
        break;
      case "EC":
        s = {
          crv: e.crv,
          kty: e.kty,
          x: e.x,
          y: e.y
        };
        break;
      case "OKP":
        s = {
          crv: e.crv,
          kty: e.kty,
          x: e.x
        };
        break;
      case "oct":
        s = {
          crv: e.k,
          kty: e.kty
        };
        break;
      default:
        throw new Error("Unknown jwk type");
    }
    const i = await S.hash("SHA-256", JSON.stringify(s));
    return S.encodeBase64Url(i);
  }
  static async generateDPoPProof({
    url: e,
    accessToken: s,
    httpMethod: i,
    keyPair: r,
    nonce: n
  }) {
    let o, a;
    const c = {
      jti: window.crypto.randomUUID(),
      htm: i ?? "GET",
      htu: e,
      iat: Math.floor(Date.now() / 1e3)
    };
    s && (o = await S.hash("SHA-256", s), a = S.encodeBase64Url(o), c.ath = a), n && (c.nonce = n);
    try {
      const l = await crypto.subtle.exportKey("jwk", r.publicKey), d = {
        alg: "ES256",
        typ: "dpop+jwt",
        jwk: {
          crv: l.crv,
          kty: l.kty,
          x: l.x,
          y: l.y
        }
      };
      return await j.generateSignedJwt(d, c, r.privateKey);
    } catch (l) {
      throw l instanceof TypeError ? new Error(`Error exporting dpop public key: ${l.message}`) : l;
    }
  }
  static async generateDPoPJkt(e) {
    try {
      const s = await crypto.subtle.exportKey("jwk", e.publicKey);
      return await S.customCalculateJwkThumbprint(s);
    } catch (s) {
      throw s instanceof TypeError ? new Error(`Could not retrieve dpop keys from storage: ${s.message}`) : s;
    }
  }
  static async generateDPoPKeys() {
    return await window.crypto.subtle.generateKey(
      {
        name: "ECDSA",
        namedCurve: "P-256"
      },
      !1,
      ["sign", "verify"]
    );
  }
  /**
   * Generates a client assertion JWT for client_secret_jwt authentication
   * @param client_id The client identifier
   * @param client_secret The client secret
   * @param audience The token endpoint URL (audience)
   * @param algorithm The HMAC algorithm to use (HS256, HS384, HS512). Defaults to HS256
   */
  static async generateClientAssertionJwt(e, s, i, r = "HS256") {
    const n = Math.floor(Date.now() / 1e3), o = {
      alg: r,
      typ: "JWT"
    }, a = {
      iss: e,
      sub: e,
      aud: i,
      jti: S.generateUUIDv4(),
      exp: n + 300,
      // 5 minutes
      iat: n
    }, l = {
      HS256: "SHA-256",
      HS384: "SHA-384",
      HS512: "SHA-512"
    }[r];
    if (!l)
      throw new Error(`Unsupported algorithm: ${r}. Supported algorithms are: HS256, HS384, HS512`);
    const d = new TextEncoder(), h = await crypto.subtle.importKey(
      "raw",
      d.encode(s),
      { name: "HMAC", hash: l },
      !1,
      ["sign"]
    );
    return await j.generateSignedJwtWithHmac(o, a, h);
  }
};
ae.encodeBase64Url = (t) => K(t).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
var p = ae, C = class {
  constructor(t) {
    this._name = t, this._callbacks = [], this._logger = new g(`Event('${this._name}')`);
  }
  addHandler(t) {
    return this._callbacks.push(t), () => this.removeHandler(t);
  }
  removeHandler(t) {
    const e = this._callbacks.lastIndexOf(t);
    e >= 0 && this._callbacks.splice(e, 1);
  }
  async raise(...t) {
    this._logger.debug("raise:", ...t);
    for (const e of this._callbacks)
      await e(...t);
  }
}, se = class {
  /**
   * Populates a map of window features with a placement centered in front of
   * the current window. If no explicit width is given, a default value is
   * binned into [800, 720, 600, 480, 360] based on the current window's width.
   */
  static center({ ...t }) {
    var e, s, i;
    return t.width == null && (t.width = (e = [800, 720, 600, 480].find((r) => r <= window.outerWidth / 1.618)) != null ? e : 360), (s = t.left) != null || (t.left = Math.max(0, Math.round(window.screenX + (window.outerWidth - t.width) / 2))), t.height != null && ((i = t.top) != null || (t.top = Math.max(0, Math.round(window.screenY + (window.outerHeight - t.height) / 2)))), t;
  }
  static serialize(t) {
    return Object.entries(t).filter(([, e]) => e != null).map(([e, s]) => `${e}=${typeof s != "boolean" ? s : s ? "yes" : "no"}`).join(",");
  }
}, I = class $ extends C {
  constructor() {
    super(...arguments), this._logger = new g(`Timer('${this._name}')`), this._timerHandle = null, this._expiration = 0, this._callback = () => {
      const e = this._expiration - $.getEpochTime();
      this._logger.debug("timer completes in", e), this._expiration <= $.getEpochTime() && (this.cancel(), super.raise());
    };
  }
  // get the time
  static getEpochTime() {
    return Math.floor(Date.now() / 1e3);
  }
  init(e) {
    const s = this._logger.create("init");
    e = Math.max(Math.floor(e), 1);
    const i = $.getEpochTime() + e;
    if (this.expiration === i && this._timerHandle) {
      s.debug("skipping since already initialized for expiration at", this.expiration);
      return;
    }
    this.cancel(), s.debug("using duration", e), this._expiration = i;
    const r = Math.min(e, 5);
    this._timerHandle = setInterval(this._callback, r * 1e3);
  }
  get expiration() {
    return this._expiration;
  }
  cancel() {
    this._logger.create("cancel"), this._timerHandle && (clearInterval(this._timerHandle), this._timerHandle = null);
  }
}, F = class {
  static readParams(t, e = "query") {
    if (!t) throw new TypeError("Invalid URL");
    const i = new URL(t, "http://127.0.0.1")[e === "fragment" ? "hash" : "search"];
    return new URLSearchParams(i.slice(1));
  }
}, N = ";", M = class extends Error {
  constructor(t, e) {
    var s, i, r;
    if (super(t.error_description || t.error || ""), this.form = e, this.name = "ErrorResponse", !t.error)
      throw g.error("ErrorResponse", "No error passed"), new Error("No error passed");
    this.error = t.error, this.error_description = (s = t.error_description) != null ? s : null, this.error_uri = (i = t.error_uri) != null ? i : null, this.state = t.userState, this.session_state = (r = t.session_state) != null ? r : null, this.url_state = t.url_state;
  }
}, Q = class extends Error {
  constructor(t) {
    super(t), this.name = "ErrorTimeout";
  }
}, je = class {
  constructor(t) {
    this._logger = new g("AccessTokenEvents"), this._expiringTimer = new I("Access token expiring"), this._expiredTimer = new I("Access token expired"), this._expiringNotificationTimeInSeconds = t.expiringNotificationTimeInSeconds;
  }
  async load(t) {
    const e = this._logger.create("load");
    if (t.access_token && t.expires_in !== void 0) {
      const s = t.expires_in;
      if (e.debug("access token present, remaining duration:", s), s > 0) {
        let r = s - this._expiringNotificationTimeInSeconds;
        r <= 0 && (r = 1), e.debug("registering expiring timer, raising in", r, "seconds"), this._expiringTimer.init(r);
      } else
        e.debug("canceling existing expiring timer because we're past expiration."), this._expiringTimer.cancel();
      const i = s + 1;
      e.debug("registering expired timer, raising in", i, "seconds"), this._expiredTimer.init(i);
    } else
      this._expiringTimer.cancel(), this._expiredTimer.cancel();
  }
  async unload() {
    this._logger.debug("unload: canceling existing access token timers"), this._expiringTimer.cancel(), this._expiredTimer.cancel();
  }
  /**
   * Add callback: Raised prior to the access token expiring.
   */
  addAccessTokenExpiring(t) {
    return this._expiringTimer.addHandler(t);
  }
  /**
   * Remove callback: Raised prior to the access token expiring.
   */
  removeAccessTokenExpiring(t) {
    this._expiringTimer.removeHandler(t);
  }
  /**
   * Add callback: Raised after the access token has expired.
   */
  addAccessTokenExpired(t) {
    return this._expiredTimer.addHandler(t);
  }
  /**
   * Remove callback: Raised after the access token has expired.
   */
  removeAccessTokenExpired(t) {
    this._expiredTimer.removeHandler(t);
  }
}, $e = class {
  constructor(t, e, s, i, r) {
    this._callback = t, this._client_id = e, this._intervalInSeconds = i, this._stopOnError = r, this._logger = new g("CheckSessionIFrame"), this._timer = null, this._session_state = null, this._message = (o) => {
      o.origin === this._frame_origin && o.source === this._frame.contentWindow && (o.data === "error" ? (this._logger.error("error message from check session op iframe"), this._stopOnError && this.stop()) : o.data === "changed" ? (this._logger.debug("changed message from check session op iframe"), this.stop(), this._callback()) : this._logger.debug(o.data + " message from check session op iframe"));
    };
    const n = new URL(s);
    this._frame_origin = n.origin, this._frame = window.document.createElement("iframe"), this._frame.style.visibility = "hidden", this._frame.style.position = "fixed", this._frame.style.left = "-1000px", this._frame.style.top = "0", this._frame.width = "0", this._frame.height = "0", this._frame.src = n.href;
  }
  load() {
    return new Promise((t) => {
      this._frame.onload = () => {
        t();
      }, window.document.body.appendChild(this._frame), window.addEventListener("message", this._message, !1);
    });
  }
  start(t) {
    if (this._session_state === t)
      return;
    this._logger.create("start"), this.stop(), this._session_state = t;
    const e = () => {
      !this._frame.contentWindow || !this._session_state || this._frame.contentWindow.postMessage(this._client_id + " " + this._session_state, this._frame_origin);
    };
    e(), this._timer = setInterval(e, this._intervalInSeconds * 1e3);
  }
  stop() {
    this._logger.create("stop"), this._session_state = null, this._timer && (clearInterval(this._timer), this._timer = null);
  }
}, ce = class {
  constructor() {
    this._logger = new g("InMemoryWebStorage"), this._data = {};
  }
  clear() {
    this._logger.create("clear"), this._data = {};
  }
  getItem(t) {
    return this._logger.create(`getItem('${t}')`), this._data[t];
  }
  setItem(t, e) {
    this._logger.create(`setItem('${t}')`), this._data[t] = e;
  }
  removeItem(t) {
    this._logger.create(`removeItem('${t}')`), delete this._data[t];
  }
  get length() {
    return Object.getOwnPropertyNames(this._data).length;
  }
  key(t) {
    return Object.getOwnPropertyNames(this._data)[t];
  }
}, z = class extends Error {
  constructor(t, e) {
    super(e), this.name = "ErrorDPoPNonce", this.nonce = t;
  }
}, X = class {
  constructor(t = [], e = null, s = {}) {
    this._jwtHandler = e, this._extraHeaders = s, this._logger = new g("JsonService"), this._contentTypes = [], this._contentTypes.push(...t, "application/json"), e && this._contentTypes.push("application/jwt");
  }
  async fetchWithTimeout(t, e = {}) {
    const { timeoutInSeconds: s, ...i } = e;
    if (!s)
      return await fetch(t, i);
    const r = new AbortController(), n = setTimeout(() => r.abort(), s * 1e3);
    try {
      return await fetch(t, {
        ...e,
        signal: r.signal
      });
    } catch (o) {
      throw o instanceof DOMException && o.name === "AbortError" ? new Q("Network timed out") : o;
    } finally {
      clearTimeout(n);
    }
  }
  async getJson(t, {
    token: e,
    credentials: s,
    timeoutInSeconds: i
  } = {}) {
    const r = this._logger.create("getJson"), n = {
      Accept: this._contentTypes.join(", ")
    };
    e && (r.debug("token passed, setting Authorization header"), n.Authorization = "Bearer " + e), this._appendExtraHeaders(n);
    let o;
    try {
      r.debug("url:", t), o = await this.fetchWithTimeout(t, { method: "GET", headers: n, timeoutInSeconds: i, credentials: s });
    } catch (l) {
      throw r.error("Network Error"), l;
    }
    r.debug("HTTP response received, status", o.status);
    const a = o.headers.get("Content-Type");
    if (a && !this._contentTypes.find((l) => a.startsWith(l)) && r.throw(new Error(`Invalid response Content-Type: ${a ?? "undefined"}, from URL: ${t}`)), o.ok && this._jwtHandler && a?.startsWith("application/jwt"))
      return await this._jwtHandler(await o.text());
    let c;
    try {
      c = await o.json();
    } catch (l) {
      throw r.error("Error parsing JSON response", l), o.ok ? l : new Error(`${o.statusText} (${o.status})`);
    }
    if (!o.ok)
      throw r.error("Error from server:", c), c.error ? new M(c) : new Error(`${o.statusText} (${o.status}): ${JSON.stringify(c)}`);
    return c;
  }
  async postForm(t, {
    body: e,
    basicAuth: s,
    timeoutInSeconds: i,
    initCredentials: r,
    extraHeaders: n
  }) {
    const o = this._logger.create("postForm"), a = {
      Accept: this._contentTypes.join(", "),
      "Content-Type": "application/x-www-form-urlencoded",
      ...n
    };
    s !== void 0 && (a.Authorization = "Basic " + s), this._appendExtraHeaders(a);
    let c;
    try {
      o.debug("url:", t), c = await this.fetchWithTimeout(t, { method: "POST", headers: a, body: e, timeoutInSeconds: i, credentials: r });
    } catch (_) {
      throw o.error("Network error"), _;
    }
    o.debug("HTTP response received, status", c.status);
    const l = c.headers.get("Content-Type");
    if (l && !this._contentTypes.find((_) => l.startsWith(_)))
      throw new Error(`Invalid response Content-Type: ${l ?? "undefined"}, from URL: ${t}`);
    const d = await c.text();
    let h = {};
    if (d)
      try {
        h = JSON.parse(d);
      } catch (_) {
        throw o.error("Error parsing JSON response", _), c.ok ? _ : new Error(`${c.statusText} (${c.status})`);
      }
    if (!c.ok) {
      if (o.error("Error from server:", h), c.headers.has("dpop-nonce")) {
        const _ = c.headers.get("dpop-nonce");
        throw new z(_, `${JSON.stringify(h)}`);
      }
      throw h.error ? new M(h, e) : new Error(`${c.statusText} (${c.status}): ${JSON.stringify(h)}`);
    }
    return h;
  }
  _appendExtraHeaders(t) {
    const e = this._logger.create("appendExtraHeaders"), s = Object.keys(this._extraHeaders), i = [
      "accept",
      "content-type"
    ], r = [
      "authorization"
    ];
    s.length !== 0 && s.forEach((n) => {
      if (i.includes(n.toLocaleLowerCase())) {
        e.warn("Protected header could not be set", n, i);
        return;
      }
      if (r.includes(n.toLocaleLowerCase()) && Object.keys(t).includes(n)) {
        e.warn("Header could not be overridden", n, r);
        return;
      }
      const o = typeof this._extraHeaders[n] == "function" ? this._extraHeaders[n]() : this._extraHeaders[n];
      o && o !== "" && (t[n] = o);
    });
  }
}, De = class {
  constructor(t) {
    this._settings = t, this._logger = new g("MetadataService"), this._signingKeys = null, this._metadata = null, this._metadataUrl = this._settings.metadataUrl, this._jsonService = new X(
      ["application/jwk-set+json"],
      null,
      this._settings.extraHeaders
    ), this._settings.signingKeys && (this._logger.debug("using signingKeys from settings"), this._signingKeys = this._settings.signingKeys), this._settings.metadata && (this._logger.debug("using metadata from settings"), this._metadata = this._settings.metadata), this._settings.fetchRequestCredentials && (this._logger.debug("using fetchRequestCredentials from settings"), this._fetchRequestCredentials = this._settings.fetchRequestCredentials);
  }
  resetSigningKeys() {
    this._signingKeys = null;
  }
  async getMetadata() {
    const t = this._logger.create("getMetadata");
    if (this._metadata)
      return t.debug("using cached values"), this._metadata;
    if (!this._metadataUrl)
      throw t.throw(new Error("No authority or metadataUrl configured on settings")), null;
    t.debug("getting metadata from", this._metadataUrl);
    const e = await this._jsonService.getJson(this._metadataUrl, { credentials: this._fetchRequestCredentials, timeoutInSeconds: this._settings.requestTimeoutInSeconds });
    return t.debug("merging remote JSON with seed metadata"), this._metadata = Object.assign({}, e, this._settings.metadataSeed), this._metadata;
  }
  getIssuer() {
    return this._getMetadataProperty("issuer");
  }
  getAuthorizationEndpoint() {
    return this._getMetadataProperty("authorization_endpoint");
  }
  getUserInfoEndpoint() {
    return this._getMetadataProperty("userinfo_endpoint");
  }
  getTokenEndpoint(t = !0) {
    return this._getMetadataProperty("token_endpoint", t);
  }
  getCheckSessionIframe() {
    return this._getMetadataProperty("check_session_iframe", !0);
  }
  getEndSessionEndpoint() {
    return this._getMetadataProperty("end_session_endpoint", !0);
  }
  getRevocationEndpoint(t = !0) {
    return this._getMetadataProperty("revocation_endpoint", t);
  }
  getKeysEndpoint(t = !0) {
    return this._getMetadataProperty("jwks_uri", t);
  }
  async _getMetadataProperty(t, e = !1) {
    const s = this._logger.create(`_getMetadataProperty('${t}')`), i = await this.getMetadata();
    if (s.debug("resolved"), i[t] === void 0) {
      if (e === !0) {
        s.warn("Metadata does not contain optional property");
        return;
      }
      s.throw(new Error("Metadata does not contain property " + t));
    }
    return i[t];
  }
  async getSigningKeys() {
    const t = this._logger.create("getSigningKeys");
    if (this._signingKeys)
      return t.debug("returning signingKeys from cache"), this._signingKeys;
    const e = await this.getKeysEndpoint(!1);
    t.debug("got jwks_uri", e);
    const s = await this._jsonService.getJson(e, { timeoutInSeconds: this._settings.requestTimeoutInSeconds });
    if (t.debug("got key set", s), !Array.isArray(s.keys))
      throw t.throw(new Error("Missing keys on keyset")), null;
    return this._signingKeys = s.keys, this._signingKeys;
  }
}, le = class {
  constructor({
    prefix: t = "oidc.",
    store: e = localStorage
  } = {}) {
    this._logger = new g("WebStorageStateStore"), this._store = e, this._prefix = t;
  }
  async set(t, e) {
    this._logger.create(`set('${t}')`), t = this._prefix + t, await this._store.setItem(t, e);
  }
  async get(t) {
    return this._logger.create(`get('${t}')`), t = this._prefix + t, await this._store.getItem(t);
  }
  async remove(t) {
    this._logger.create(`remove('${t}')`), t = this._prefix + t;
    const e = await this._store.getItem(t);
    return await this._store.removeItem(t), e;
  }
  async getAllKeys() {
    this._logger.create("getAllKeys");
    const t = await this._store.length, e = [];
    for (let s = 0; s < t; s++) {
      const i = await this._store.key(s);
      i && i.indexOf(this._prefix) === 0 && e.push(i.substr(this._prefix.length));
    }
    return e;
  }
}, Je = "code", We = "openid", Le = "client_secret_post", Ke = 900, B = class {
  constructor({
    // metadata related
    authority: t,
    metadataUrl: e,
    metadata: s,
    signingKeys: i,
    metadataSeed: r,
    // client related
    client_id: n,
    client_secret: o,
    response_type: a = Je,
    scope: c = We,
    redirect_uri: l,
    post_logout_redirect_uri: d,
    client_authentication: h = Le,
    token_endpoint_auth_signing_alg: _ = "HS256",
    // optional protocol
    prompt: u,
    display: f,
    max_age: v,
    ui_locales: x,
    acr_values: A,
    resource: P,
    response_mode: O,
    // behavior flags
    filterProtocolClaims: U = !0,
    loadUserInfo: y = !1,
    requestTimeoutInSeconds: w,
    staleStateAgeInSeconds: T = Ke,
    mergeClaimsStrategy: R = { array: "replace" },
    disablePKCE: m = !1,
    // other behavior
    stateStore: q,
    revokeTokenAdditionalContentTypes: be,
    fetchRequestCredentials: Y,
    refreshTokenAllowedScope: ke,
    // extra
    extraQueryParams: Ee = {},
    extraTokenParams: Te = {},
    extraHeaders: Re = {},
    dpop: Ie,
    omitScopeWhenRequesting: Pe = !1
  }) {
    var Z;
    if (this.authority = t, e ? this.metadataUrl = e : (this.metadataUrl = t, t && (this.metadataUrl.endsWith("/") || (this.metadataUrl += "/"), this.metadataUrl += ".well-known/openid-configuration")), this.metadata = s, this.metadataSeed = r, this.signingKeys = i, this.client_id = n, this.client_secret = o, this.response_type = a, this.scope = c, this.redirect_uri = l, this.post_logout_redirect_uri = d, this.client_authentication = h, this.token_endpoint_auth_signing_alg = _, this.prompt = u, this.display = f, this.max_age = v, this.ui_locales = x, this.acr_values = A, this.resource = P, this.response_mode = O, this.filterProtocolClaims = U ?? !0, this.loadUserInfo = !!y, this.staleStateAgeInSeconds = T, this.mergeClaimsStrategy = R, this.omitScopeWhenRequesting = Pe, this.disablePKCE = !!m, this.revokeTokenAdditionalContentTypes = be, this.fetchRequestCredentials = Y || "same-origin", this.requestTimeoutInSeconds = w, q)
      this.stateStore = q;
    else {
      const Ue = typeof window < "u" ? window.localStorage : new ce();
      this.stateStore = new le({ store: Ue });
    }
    if (this.refreshTokenAllowedScope = ke, this.extraQueryParams = Ee, this.extraTokenParams = Te, this.extraHeaders = Re, this.dpop = Ie, this.dpop && !((Z = this.dpop) != null && Z.store))
      throw new Error("A DPoPStore is required when dpop is enabled");
  }
}, Fe = class {
  constructor(t, e) {
    this._settings = t, this._metadataService = e, this._logger = new g("UserInfoService"), this._getClaimsFromJwt = async (s) => {
      const i = this._logger.create("_getClaimsFromJwt");
      try {
        const r = j.decode(s);
        return i.debug("JWT decoding successful"), r;
      } catch (r) {
        throw i.error("Error parsing JWT response"), r;
      }
    }, this._jsonService = new X(
      void 0,
      this._getClaimsFromJwt,
      this._settings.extraHeaders
    );
  }
  async getClaims(t) {
    const e = this._logger.create("getClaims");
    t || this._logger.throw(new Error("No token passed"));
    const s = await this._metadataService.getUserInfoEndpoint();
    e.debug("got userinfo url", s);
    const i = await this._jsonService.getJson(s, {
      token: t,
      credentials: this._settings.fetchRequestCredentials,
      timeoutInSeconds: this._settings.requestTimeoutInSeconds
    });
    return e.debug("got claims", i), i;
  }
}, de = class {
  constructor(t, e) {
    this._settings = t, this._metadataService = e, this._logger = new g("TokenClient"), this._jsonService = new X(
      this._settings.revokeTokenAdditionalContentTypes,
      null,
      this._settings.extraHeaders
    );
  }
  /**
   * Exchange code.
   *
   * @see https://www.rfc-editor.org/rfc/rfc6749#section-4.1.3
   */
  async exchangeCode({
    grant_type: t = "authorization_code",
    redirect_uri: e = this._settings.redirect_uri,
    client_id: s = this._settings.client_id,
    client_secret: i = this._settings.client_secret,
    extraHeaders: r,
    ...n
  }) {
    const o = this._logger.create("exchangeCode");
    s || o.throw(new Error("A client_id is required")), e || o.throw(new Error("A redirect_uri is required")), n.code || o.throw(new Error("A code is required"));
    const a = new URLSearchParams({ grant_type: t, redirect_uri: e });
    for (const [h, _] of Object.entries(n))
      _ != null && a.set(h, _);
    if ((this._settings.client_authentication === "client_secret_basic" || this._settings.client_authentication === "client_secret_jwt") && i == null)
      throw o.throw(new Error("A client_secret is required")), null;
    let c;
    const l = await this._metadataService.getTokenEndpoint(!1);
    switch (this._settings.client_authentication) {
      case "client_secret_basic":
        c = p.generateBasicAuth(s, i);
        break;
      case "client_secret_post":
        a.append("client_id", s), i && a.append("client_secret", i);
        break;
      case "client_secret_jwt": {
        const h = await p.generateClientAssertionJwt(s, i, l, this._settings.token_endpoint_auth_signing_alg);
        a.append("client_id", s), a.append("client_assertion_type", "urn:ietf:params:oauth:client-assertion-type:jwt-bearer"), a.append("client_assertion", h);
        break;
      }
    }
    o.debug("got token endpoint");
    const d = await this._jsonService.postForm(l, {
      body: a,
      basicAuth: c,
      timeoutInSeconds: this._settings.requestTimeoutInSeconds,
      initCredentials: this._settings.fetchRequestCredentials,
      extraHeaders: r
    });
    return o.debug("got response"), d;
  }
  /**
   * Exchange credentials.
   *
   * @see https://www.rfc-editor.org/rfc/rfc6749#section-4.3.2
   */
  async exchangeCredentials({
    grant_type: t = "password",
    client_id: e = this._settings.client_id,
    client_secret: s = this._settings.client_secret,
    scope: i = this._settings.scope,
    ...r
  }) {
    const n = this._logger.create("exchangeCredentials");
    e || n.throw(new Error("A client_id is required"));
    const o = new URLSearchParams({ grant_type: t });
    this._settings.omitScopeWhenRequesting || o.set("scope", i);
    for (const [d, h] of Object.entries(r))
      h != null && o.set(d, h);
    if ((this._settings.client_authentication === "client_secret_basic" || this._settings.client_authentication === "client_secret_jwt") && s == null)
      throw n.throw(new Error("A client_secret is required")), null;
    let a;
    const c = await this._metadataService.getTokenEndpoint(!1);
    switch (this._settings.client_authentication) {
      case "client_secret_basic":
        a = p.generateBasicAuth(e, s);
        break;
      case "client_secret_post":
        o.append("client_id", e), s && o.append("client_secret", s);
        break;
      case "client_secret_jwt": {
        const d = await p.generateClientAssertionJwt(e, s, c, this._settings.token_endpoint_auth_signing_alg);
        o.append("client_id", e), o.append("client_assertion_type", "urn:ietf:params:oauth:client-assertion-type:jwt-bearer"), o.append("client_assertion", d);
        break;
      }
    }
    n.debug("got token endpoint");
    const l = await this._jsonService.postForm(c, { body: o, basicAuth: a, timeoutInSeconds: this._settings.requestTimeoutInSeconds, initCredentials: this._settings.fetchRequestCredentials });
    return n.debug("got response"), l;
  }
  /**
   * Exchange a refresh token.
   *
   * @see https://www.rfc-editor.org/rfc/rfc6749#section-6
   */
  async exchangeRefreshToken({
    grant_type: t = "refresh_token",
    client_id: e = this._settings.client_id,
    client_secret: s = this._settings.client_secret,
    timeoutInSeconds: i,
    extraHeaders: r,
    ...n
  }) {
    const o = this._logger.create("exchangeRefreshToken");
    e || o.throw(new Error("A client_id is required")), n.refresh_token || o.throw(new Error("A refresh_token is required"));
    const a = new URLSearchParams({ grant_type: t });
    for (const [h, _] of Object.entries(n))
      Array.isArray(_) ? _.forEach((u) => a.append(h, u)) : _ != null && a.set(h, _);
    if ((this._settings.client_authentication === "client_secret_basic" || this._settings.client_authentication === "client_secret_jwt") && s == null)
      throw o.throw(new Error("A client_secret is required")), null;
    let c;
    const l = await this._metadataService.getTokenEndpoint(!1);
    switch (this._settings.client_authentication) {
      case "client_secret_basic":
        c = p.generateBasicAuth(e, s);
        break;
      case "client_secret_post":
        a.append("client_id", e), s && a.append("client_secret", s);
        break;
      case "client_secret_jwt": {
        const h = await p.generateClientAssertionJwt(e, s, l, this._settings.token_endpoint_auth_signing_alg);
        a.append("client_id", e), a.append("client_assertion_type", "urn:ietf:params:oauth:client-assertion-type:jwt-bearer"), a.append("client_assertion", h);
        break;
      }
    }
    o.debug("got token endpoint");
    const d = await this._jsonService.postForm(l, { body: a, basicAuth: c, timeoutInSeconds: i, initCredentials: this._settings.fetchRequestCredentials, extraHeaders: r });
    return o.debug("got response"), d;
  }
  /**
   * Revoke an access or refresh token.
   *
   * @see https://datatracker.ietf.org/doc/html/rfc7009#section-2.1
   */
  async revoke(t) {
    var e;
    const s = this._logger.create("revoke");
    t.token || s.throw(new Error("A token is required"));
    const i = await this._metadataService.getRevocationEndpoint(!1);
    s.debug(`got revocation endpoint, revoking ${(e = t.token_type_hint) != null ? e : "default token type"}`);
    const r = new URLSearchParams();
    for (const [n, o] of Object.entries(t))
      o != null && r.set(n, o);
    r.set("client_id", this._settings.client_id), this._settings.client_secret && r.set("client_secret", this._settings.client_secret), await this._jsonService.postForm(i, { body: r, timeoutInSeconds: this._settings.requestTimeoutInSeconds }), s.debug("got response");
  }
}, ze = class {
  constructor(t, e, s) {
    this._settings = t, this._metadataService = e, this._claimsService = s, this._logger = new g("ResponseValidator"), this._userInfoService = new Fe(this._settings, this._metadataService), this._tokenClient = new de(this._settings, this._metadataService);
  }
  async validateSigninResponse(t, e, s) {
    const i = this._logger.create("validateSigninResponse");
    this._processSigninState(t, e), i.debug("state processed"), await this._processCode(t, e, s), i.debug("code processed"), t.isOpenId && this._validateIdTokenAttributes(t, "", e.nonce), i.debug("tokens validated"), await this._processClaims(t, e?.skipUserInfo, t.isOpenId), i.debug("claims processed");
  }
  async validateCredentialsResponse(t, e) {
    const s = this._logger.create("validateCredentialsResponse"), i = t.isOpenId && !!t.id_token;
    i && this._validateIdTokenAttributes(t), s.debug("tokens validated"), await this._processClaims(t, e, i), s.debug("claims processed");
  }
  async validateRefreshResponse(t, e) {
    var s, i;
    const r = this._logger.create("validateRefreshResponse");
    t.userState = e.data, (s = t.session_state) != null || (t.session_state = e.session_state), (i = t.scope) != null || (t.scope = e.scope), t.isOpenId && t.id_token && (this._validateIdTokenAttributes(t, e.id_token), r.debug("ID Token validated")), t.id_token || (t.id_token = e.id_token, t.profile = e.profile);
    const n = t.isOpenId && !!t.id_token;
    await this._processClaims(t, !1, n), r.debug("claims processed");
  }
  validateSignoutResponse(t, e) {
    const s = this._logger.create("validateSignoutResponse");
    if (e.id !== t.state && s.throw(new Error("State does not match")), s.debug("state validated"), t.userState = e.data, t.error)
      throw s.warn("Response was error", t.error), new M(t);
  }
  _processSigninState(t, e) {
    var s;
    const i = this._logger.create("_processSigninState");
    if (e.id !== t.state && i.throw(new Error("State does not match")), e.client_id || i.throw(new Error("No client_id on state")), e.authority || i.throw(new Error("No authority on state")), this._settings.authority !== e.authority && i.throw(new Error("authority mismatch on settings vs. signin state")), this._settings.client_id && this._settings.client_id !== e.client_id && i.throw(new Error("client_id mismatch on settings vs. signin state")), i.debug("state validated"), t.userState = e.data, t.url_state = e.url_state, (s = t.scope) != null || (t.scope = e.scope), t.error)
      throw i.warn("Response was error", t.error), new M(t);
    e.code_verifier && !t.code && i.throw(new Error("Expected code in response"));
  }
  async _processClaims(t, e = !1, s = !0) {
    const i = this._logger.create("_processClaims");
    if (t.profile = this._claimsService.filterProtocolClaims(t.profile), e || !this._settings.loadUserInfo || !t.access_token) {
      i.debug("not loading user info");
      return;
    }
    i.debug("loading user info");
    const r = await this._userInfoService.getClaims(t.access_token);
    i.debug("user info claims received from user info endpoint"), s && r.sub !== t.profile.sub && i.throw(new Error("subject from UserInfo response does not match subject in ID Token")), t.profile = this._claimsService.mergeClaims(t.profile, this._claimsService.filterProtocolClaims(r)), i.debug("user info claims received, updated profile:", t.profile);
  }
  async _processCode(t, e, s) {
    const i = this._logger.create("_processCode");
    if (t.code) {
      i.debug("Validating code");
      const r = await this._tokenClient.exchangeCode({
        client_id: e.client_id,
        client_secret: e.client_secret,
        code: t.code,
        redirect_uri: e.redirect_uri,
        code_verifier: e.code_verifier,
        extraHeaders: s,
        ...e.extraTokenParams
      });
      Object.assign(t, r);
    } else
      i.debug("No code to process");
  }
  _validateIdTokenAttributes(t, e, s) {
    var i;
    const r = this._logger.create("_validateIdTokenAttributes");
    r.debug("decoding ID Token JWT");
    const n = j.decode((i = t.id_token) != null ? i : "");
    if (n.sub || r.throw(new Error("ID Token is missing a subject claim")), s && n.nonce !== s && r.throw(new Error("nonce in id_token does not match nonce in client storage")), e) {
      const o = j.decode(e);
      n.sub !== o.sub && r.throw(new Error("sub in id_token does not match current sub")), n.auth_time && n.auth_time !== o.auth_time && r.throw(new Error("auth_time in id_token does not match original auth_time")), n.azp && n.azp !== o.azp && r.throw(new Error("azp in id_token does not match original azp")), !n.azp && o.azp && r.throw(new Error("azp not in id_token, but present in original id_token"));
    }
    t.profile = n;
  }
}, W = class V {
  constructor(e) {
    this.id = e.id || p.generateUUIDv4(), this.data = e.data, e.created && e.created > 0 ? this.created = e.created : this.created = I.getEpochTime(), this.request_type = e.request_type, this.url_state = e.url_state;
  }
  toStorageString() {
    return new g("State").create("toStorageString"), JSON.stringify({
      id: this.id,
      data: this.data,
      created: this.created,
      request_type: this.request_type,
      url_state: this.url_state
    });
  }
  static fromStorageString(e) {
    return g.createStatic("State", "fromStorageString"), Promise.resolve(new V(JSON.parse(e)));
  }
  static async clearStaleState(e, s) {
    const i = g.createStatic("State", "clearStaleState"), r = I.getEpochTime() - s, n = await e.getAllKeys();
    i.debug("got keys", n);
    for (let o = 0; o < n.length; o++) {
      const a = n[o], c = await e.get(a);
      let l = !1;
      if (c)
        try {
          const d = await V.fromStorageString(c);
          i.debug("got item from key:", a, d.created), d.created <= r && (l = !0);
        } catch (d) {
          i.error("Error parsing state for key:", a, d), l = !0;
        }
      else
        i.debug("no item in storage for key:", a), l = !0;
      l && (i.debug("removed item for key:", a), e.remove(a));
    }
  }
}, he = class G extends W {
  constructor(e) {
    super(e), this.code_verifier = e.code_verifier, this.code_challenge = e.code_challenge, this.authority = e.authority, this.client_id = e.client_id, this.redirect_uri = e.redirect_uri, this.scope = e.scope, this.client_secret = e.client_secret, this.extraTokenParams = e.extraTokenParams, this.response_mode = e.response_mode, this.skipUserInfo = e.skipUserInfo, this.nonce = e.nonce;
  }
  static async create(e) {
    const s = e.code_verifier === !0 ? p.generateCodeVerifier() : e.code_verifier || void 0, i = s ? await p.generateCodeChallenge(s) : void 0;
    return new G({
      ...e,
      code_verifier: s,
      code_challenge: i
    });
  }
  toStorageString() {
    return new g("SigninState").create("toStorageString"), JSON.stringify({
      id: this.id,
      data: this.data,
      created: this.created,
      request_type: this.request_type,
      url_state: this.url_state,
      code_verifier: this.code_verifier,
      authority: this.authority,
      client_id: this.client_id,
      redirect_uri: this.redirect_uri,
      scope: this.scope,
      client_secret: this.client_secret,
      extraTokenParams: this.extraTokenParams,
      response_mode: this.response_mode,
      skipUserInfo: this.skipUserInfo,
      nonce: this.nonce
    });
  }
  static fromStorageString(e) {
    g.createStatic("SigninState", "fromStorageString");
    const s = JSON.parse(e);
    return G.create(s);
  }
}, ge = class ue {
  constructor(e) {
    this.url = e.url, this.state = e.state;
  }
  static async create({
    // mandatory
    url: e,
    authority: s,
    client_id: i,
    redirect_uri: r,
    response_type: n,
    scope: o,
    // optional
    state_data: a,
    response_mode: c,
    request_type: l,
    client_secret: d,
    nonce: h,
    url_state: _,
    resource: u,
    skipUserInfo: f,
    extraQueryParams: v,
    extraTokenParams: x,
    disablePKCE: A,
    dpopJkt: P,
    omitScopeWhenRequesting: O,
    ...U
  }) {
    if (!e)
      throw this._logger.error("create: No url passed"), new Error("url");
    if (!i)
      throw this._logger.error("create: No client_id passed"), new Error("client_id");
    if (!r)
      throw this._logger.error("create: No redirect_uri passed"), new Error("redirect_uri");
    if (!n)
      throw this._logger.error("create: No response_type passed"), new Error("response_type");
    if (!o)
      throw this._logger.error("create: No scope passed"), new Error("scope");
    if (!s)
      throw this._logger.error("create: No authority passed"), new Error("authority");
    const y = await he.create({
      data: a,
      request_type: l,
      url_state: _,
      code_verifier: !A,
      client_id: i,
      authority: s,
      redirect_uri: r,
      response_mode: c,
      client_secret: d,
      scope: o,
      extraTokenParams: x,
      skipUserInfo: f,
      nonce: h
    }), w = new URL(e);
    w.searchParams.append("client_id", i), w.searchParams.append("redirect_uri", r), w.searchParams.append("response_type", n), O || w.searchParams.append("scope", o), h && w.searchParams.append("nonce", h), P && w.searchParams.append("dpop_jkt", P);
    let T = y.id;
    _ && (T = `${T}${N}${_}`), w.searchParams.append("state", T), y.code_challenge && (w.searchParams.append("code_challenge", y.code_challenge), w.searchParams.append("code_challenge_method", "S256")), u && (Array.isArray(u) ? u : [u]).forEach((m) => w.searchParams.append("resource", m));
    for (const [R, m] of Object.entries({ response_mode: c, ...U, ...v }))
      m != null && w.searchParams.append(R, m.toString());
    return new ue({
      url: w.href,
      state: y
    });
  }
};
ge._logger = new g("SigninRequest");
var Be = ge, Ve = "openid", L = class {
  constructor(t) {
    if (this.access_token = "", this.token_type = "", this.profile = {}, this.state = t.get("state"), this.session_state = t.get("session_state"), this.state) {
      const e = decodeURIComponent(this.state).split(N);
      this.state = e[0], e.length > 1 && (this.url_state = e.slice(1).join(N));
    }
    this.error = t.get("error"), this.error_description = t.get("error_description"), this.error_uri = t.get("error_uri"), this.code = t.get("code");
  }
  get expires_in() {
    if (this.expires_at !== void 0)
      return this.expires_at - I.getEpochTime();
  }
  set expires_in(t) {
    typeof t == "string" && (t = Number(t)), t !== void 0 && t >= 0 && (this.expires_at = Math.floor(t) + I.getEpochTime());
  }
  get isOpenId() {
    var t;
    return ((t = this.scope) == null ? void 0 : t.split(" ").includes(Ve)) || !!this.id_token;
  }
}, Ge = class {
  constructor({
    url: t,
    state_data: e,
    id_token_hint: s,
    post_logout_redirect_uri: i,
    extraQueryParams: r,
    request_type: n,
    client_id: o,
    url_state: a
  }) {
    if (this._logger = new g("SignoutRequest"), !t)
      throw this._logger.error("ctor: No url passed"), new Error("url");
    const c = new URL(t);
    if (s && c.searchParams.append("id_token_hint", s), o && c.searchParams.append("client_id", o), i && (c.searchParams.append("post_logout_redirect_uri", i), e || a)) {
      this.state = new W({ data: e, request_type: n, url_state: a });
      let l = this.state.id;
      a && (l = `${l}${N}${a}`), c.searchParams.append("state", l);
    }
    for (const [l, d] of Object.entries({ ...r }))
      d != null && c.searchParams.append(l, d.toString());
    this.url = c.href;
  }
}, Qe = class {
  constructor(t) {
    if (this.state = t.get("state"), this.state) {
      const e = decodeURIComponent(this.state).split(N);
      this.state = e[0], e.length > 1 && (this.url_state = e.slice(1).join(N));
    }
    this.error = t.get("error"), this.error_description = t.get("error_description"), this.error_uri = t.get("error_uri");
  }
}, Xe = [
  "nbf",
  "jti",
  "auth_time",
  "nonce",
  "acr",
  "amr",
  "azp",
  "at_hash"
  // https://openid.net/specs/openid-connect-core-1_0.html#CodeIDToken
], Ye = ["sub", "iss", "aud", "exp", "iat"], Ze = class {
  constructor(t) {
    this._settings = t, this._logger = new g("ClaimsService");
  }
  filterProtocolClaims(t) {
    const e = { ...t };
    if (this._settings.filterProtocolClaims) {
      let s;
      Array.isArray(this._settings.filterProtocolClaims) ? s = this._settings.filterProtocolClaims : s = Xe;
      for (const i of s)
        Ye.includes(i) || delete e[i];
    }
    return e;
  }
  mergeClaims(t, e) {
    const s = { ...t };
    for (const [i, r] of Object.entries(e))
      if (s[i] !== r)
        if (Array.isArray(s[i]) || Array.isArray(r))
          if (this._settings.mergeClaimsStrategy.array == "replace")
            s[i] = r;
          else {
            const n = Array.isArray(s[i]) ? s[i] : [s[i]];
            for (const o of Array.isArray(r) ? r : [r])
              n.includes(o) || n.push(o);
            s[i] = n;
          }
        else typeof s[i] == "object" && typeof r == "object" ? s[i] = this.mergeClaims(s[i], r) : s[i] = r;
    return s;
  }
}, _e = class {
  constructor(t, e) {
    this.keys = t, this.nonce = e;
  }
}, et = class {
  constructor(t, e) {
    this._logger = new g("OidcClient"), this.settings = t instanceof B ? t : new B(t), this.metadataService = e ?? new De(this.settings), this._claimsService = new Ze(this.settings), this._validator = new ze(this.settings, this.metadataService, this._claimsService), this._tokenClient = new de(this.settings, this.metadataService);
  }
  async createSigninRequest({
    state: t,
    request: e,
    request_uri: s,
    request_type: i,
    id_token_hint: r,
    login_hint: n,
    skipUserInfo: o,
    nonce: a,
    url_state: c,
    response_type: l = this.settings.response_type,
    scope: d = this.settings.scope,
    redirect_uri: h = this.settings.redirect_uri,
    prompt: _ = this.settings.prompt,
    display: u = this.settings.display,
    max_age: f = this.settings.max_age,
    ui_locales: v = this.settings.ui_locales,
    acr_values: x = this.settings.acr_values,
    resource: A = this.settings.resource,
    response_mode: P = this.settings.response_mode,
    extraQueryParams: O = this.settings.extraQueryParams,
    extraTokenParams: U = this.settings.extraTokenParams,
    dpopJkt: y,
    omitScopeWhenRequesting: w = this.settings.omitScopeWhenRequesting
  }) {
    const T = this._logger.create("createSigninRequest");
    if (l !== "code")
      throw new Error("Only the Authorization Code flow (with PKCE) is supported");
    const R = await this.metadataService.getAuthorizationEndpoint();
    T.debug("Received authorization endpoint", R);
    const m = await Be.create({
      url: R,
      authority: this.settings.authority,
      client_id: this.settings.client_id,
      redirect_uri: h,
      response_type: l,
      scope: d,
      state_data: t,
      url_state: c,
      prompt: _,
      display: u,
      max_age: f,
      ui_locales: v,
      id_token_hint: r,
      login_hint: n,
      acr_values: x,
      dpopJkt: y,
      resource: A,
      request: e,
      request_uri: s,
      extraQueryParams: O,
      extraTokenParams: U,
      request_type: i,
      response_mode: P,
      client_secret: this.settings.client_secret,
      skipUserInfo: o,
      nonce: a,
      disablePKCE: this.settings.disablePKCE,
      omitScopeWhenRequesting: w
    });
    await this.clearStaleState();
    const q = m.state;
    return await this.settings.stateStore.set(q.id, q.toStorageString()), m;
  }
  async readSigninResponseState(t, e = !1) {
    const s = this._logger.create("readSigninResponseState"), i = new L(F.readParams(t, this.settings.response_mode));
    if (!i.state)
      throw s.throw(new Error("No state in response")), null;
    const r = await this.settings.stateStore[e ? "remove" : "get"](i.state);
    if (!r)
      throw s.throw(new Error("No matching state found in storage")), null;
    return { state: await he.fromStorageString(r), response: i };
  }
  async processSigninResponse(t, e, s = !0) {
    const i = this._logger.create("processSigninResponse"), { state: r, response: n } = await this.readSigninResponseState(t, s);
    if (i.debug("received state from storage; validating response"), this.settings.dpop && this.settings.dpop.store) {
      const o = await this.getDpopProof(this.settings.dpop.store);
      e = { ...e, DPoP: o };
    }
    try {
      await this._validator.validateSigninResponse(n, r, e);
    } catch (o) {
      if (o instanceof z && this.settings.dpop) {
        const a = await this.getDpopProof(this.settings.dpop.store, o.nonce);
        e.DPoP = a, await this._validator.validateSigninResponse(n, r, e);
      } else
        throw o;
    }
    return n;
  }
  async getDpopProof(t, e) {
    let s, i;
    return (await t.getAllKeys()).includes(this.settings.client_id) ? (i = await t.get(this.settings.client_id), i.nonce !== e && e && (i.nonce = e, await t.set(this.settings.client_id, i))) : (s = await p.generateDPoPKeys(), i = new _e(s, e), await t.set(this.settings.client_id, i)), await p.generateDPoPProof({
      url: await this.metadataService.getTokenEndpoint(!1),
      httpMethod: "POST",
      keyPair: i.keys,
      nonce: i.nonce
    });
  }
  async processResourceOwnerPasswordCredentials({
    username: t,
    password: e,
    skipUserInfo: s = !1,
    extraTokenParams: i = {}
  }) {
    const r = await this._tokenClient.exchangeCredentials({ username: t, password: e, ...i }), n = new L(new URLSearchParams());
    return Object.assign(n, r), await this._validator.validateCredentialsResponse(n, s), n;
  }
  async useRefreshToken({
    state: t,
    redirect_uri: e,
    resource: s,
    timeoutInSeconds: i,
    extraHeaders: r,
    extraTokenParams: n
  }) {
    var o;
    const a = this._logger.create("useRefreshToken");
    let c;
    if (this.settings.refreshTokenAllowedScope === void 0)
      c = t.scope;
    else {
      const h = this.settings.refreshTokenAllowedScope.split(" ");
      c = (((o = t.scope) == null ? void 0 : o.split(" ")) || []).filter((u) => h.includes(u)).join(" ");
    }
    if (this.settings.dpop && this.settings.dpop.store) {
      const h = await this.getDpopProof(this.settings.dpop.store);
      r = { ...r, DPoP: h };
    }
    let l;
    try {
      l = await this._tokenClient.exchangeRefreshToken({
        refresh_token: t.refresh_token,
        // provide the (possible filtered) scope list
        scope: c,
        redirect_uri: e,
        resource: s,
        timeoutInSeconds: i,
        extraHeaders: r,
        ...n
      });
    } catch (h) {
      if (h instanceof z && this.settings.dpop)
        r.DPoP = await this.getDpopProof(this.settings.dpop.store, h.nonce), l = await this._tokenClient.exchangeRefreshToken({
          refresh_token: t.refresh_token,
          // provide the (possible filtered) scope list
          scope: c,
          redirect_uri: e,
          resource: s,
          timeoutInSeconds: i,
          extraHeaders: r,
          ...n
        });
      else
        throw h;
    }
    const d = new L(new URLSearchParams());
    return Object.assign(d, l), a.debug("validating response", d), await this._validator.validateRefreshResponse(d, {
      ...t,
      // override the scope in the state handed over to the validator
      // so it can set the granted scope to the requested scope in case none is included in the response
      scope: c
    }), d;
  }
  async createSignoutRequest({
    state: t,
    id_token_hint: e,
    client_id: s,
    request_type: i,
    url_state: r,
    post_logout_redirect_uri: n = this.settings.post_logout_redirect_uri,
    extraQueryParams: o = this.settings.extraQueryParams
  } = {}) {
    const a = this._logger.create("createSignoutRequest"), c = await this.metadataService.getEndSessionEndpoint();
    if (!c)
      throw a.throw(new Error("No end session endpoint")), null;
    a.debug("Received end session endpoint", c), !s && n && !e && (s = this.settings.client_id);
    const l = new Ge({
      url: c,
      id_token_hint: e,
      client_id: s,
      post_logout_redirect_uri: n,
      state_data: t,
      extraQueryParams: o,
      request_type: i,
      url_state: r
    });
    await this.clearStaleState();
    const d = l.state;
    return d && (a.debug("Signout request has state to persist"), await this.settings.stateStore.set(d.id, d.toStorageString())), l;
  }
  async readSignoutResponseState(t, e = !1) {
    const s = this._logger.create("readSignoutResponseState"), i = new Qe(F.readParams(t, this.settings.response_mode));
    if (!i.state) {
      if (s.debug("No state in response"), i.error)
        throw s.warn("Response was error:", i.error), new M(i);
      return { state: void 0, response: i };
    }
    const r = await this.settings.stateStore[e ? "remove" : "get"](i.state);
    if (!r)
      throw s.throw(new Error("No matching state found in storage")), null;
    return { state: await W.fromStorageString(r), response: i };
  }
  async processSignoutResponse(t) {
    const e = this._logger.create("processSignoutResponse"), { state: s, response: i } = await this.readSignoutResponseState(t, !0);
    return s ? (e.debug("Received state from storage; validating response"), this._validator.validateSignoutResponse(i, s)) : e.debug("No state from storage; skipping response validation"), i;
  }
  clearStaleState() {
    return this._logger.create("clearStaleState"), W.clearStaleState(this.settings.stateStore, this.settings.staleStateAgeInSeconds);
  }
  async revokeToken(t, e) {
    return this._logger.create("revokeToken"), await this._tokenClient.revoke({
      token: t,
      token_type_hint: e
    });
  }
}, tt = class {
  constructor(t) {
    this._userManager = t, this._logger = new g("SessionMonitor"), this._start = async (e) => {
      const s = e.session_state;
      if (!s)
        return;
      const i = this._logger.create("_start");
      if (e.profile ? (this._sub = e.profile.sub, i.debug("session_state", s, ", sub", this._sub)) : (this._sub = void 0, i.debug("session_state", s, ", anonymous user")), this._checkSessionIFrame) {
        this._checkSessionIFrame.start(s);
        return;
      }
      try {
        const r = await this._userManager.metadataService.getCheckSessionIframe();
        if (r) {
          i.debug("initializing check session iframe");
          const n = this._userManager.settings.client_id, o = this._userManager.settings.checkSessionIntervalInSeconds, a = this._userManager.settings.stopCheckSessionOnError, c = new $e(this._callback, n, r, o, a);
          await c.load(), this._checkSessionIFrame = c, c.start(s);
        } else
          i.warn("no check session iframe found in the metadata");
      } catch (r) {
        i.error("Error from getCheckSessionIframe:", r instanceof Error ? r.message : r);
      }
    }, this._stop = () => {
      const e = this._logger.create("_stop");
      if (this._sub = void 0, this._checkSessionIFrame && this._checkSessionIFrame.stop(), this._userManager.settings.monitorAnonymousSession) {
        const s = setInterval(async () => {
          clearInterval(s);
          try {
            const i = await this._userManager.querySessionStatus();
            if (i) {
              const r = {
                session_state: i.session_state,
                profile: i.sub ? {
                  sub: i.sub
                } : null
              };
              this._start(r);
            }
          } catch (i) {
            e.error("error from querySessionStatus", i instanceof Error ? i.message : i);
          }
        }, 1e3);
      }
    }, this._callback = async () => {
      const e = this._logger.create("_callback");
      try {
        const s = await this._userManager.querySessionStatus();
        let i = !0;
        s && this._checkSessionIFrame ? s.sub === this._sub ? (i = !1, this._checkSessionIFrame.start(s.session_state), e.debug("same sub still logged in at OP, session state has changed, restarting check session iframe; session_state", s.session_state), await this._userManager.events._raiseUserSessionChanged()) : e.debug("different subject signed into OP", s.sub) : e.debug("subject no longer signed into OP"), i ? this._sub ? await this._userManager.events._raiseUserSignedOut() : await this._userManager.events._raiseUserSignedIn() : e.debug("no change in session detected, no event to raise");
      } catch (s) {
        this._sub && (e.debug("Error calling queryCurrentSigninSession; raising signed out event", s), await this._userManager.events._raiseUserSignedOut());
      }
    }, t || this._logger.throw(new Error("No user manager passed")), this._userManager.events.addUserLoaded(this._start), this._userManager.events.addUserUnloaded(this._stop), this._init().catch((e) => {
      this._logger.error(e);
    });
  }
  async _init() {
    this._logger.create("_init");
    const t = await this._userManager.getUser();
    if (t)
      this._start(t);
    else if (this._userManager.settings.monitorAnonymousSession) {
      const e = await this._userManager.querySessionStatus();
      if (e) {
        const s = {
          session_state: e.session_state,
          profile: e.sub ? {
            sub: e.sub
          } : null
        };
        this._start(s);
      }
    }
  }
}, D = class pe {
  constructor(e) {
    var s;
    this.id_token = e.id_token, this.session_state = (s = e.session_state) != null ? s : null, this.access_token = e.access_token, this.refresh_token = e.refresh_token, this.token_type = e.token_type, this.scope = e.scope, this.profile = e.profile, this.expires_at = e.expires_at, this.state = e.userState, this.url_state = e.url_state;
  }
  /** Computed number of seconds the access token has remaining. */
  get expires_in() {
    if (this.expires_at !== void 0)
      return this.expires_at - I.getEpochTime();
  }
  set expires_in(e) {
    e !== void 0 && (this.expires_at = Math.floor(e) + I.getEpochTime());
  }
  /** Computed value indicating if the access token is expired. */
  get expired() {
    const e = this.expires_in;
    if (e !== void 0)
      return e <= 0;
  }
  /** Array representing the parsed values from the `scope`. */
  get scopes() {
    var e, s;
    return (s = (e = this.scope) == null ? void 0 : e.split(" ")) != null ? s : [];
  }
  toStorageString() {
    return new g("User").create("toStorageString"), JSON.stringify({
      id_token: this.id_token,
      session_state: this.session_state,
      access_token: this.access_token,
      refresh_token: this.refresh_token,
      token_type: this.token_type,
      scope: this.scope,
      profile: this.profile,
      expires_at: this.expires_at
    });
  }
  static fromStorageString(e) {
    return g.createStatic("User", "fromStorageString"), new pe(JSON.parse(e));
  }
}, ie = "oidc-client", we = class {
  constructor() {
    this._abort = new C("Window navigation aborted"), this._disposeHandlers = /* @__PURE__ */ new Set(), this._window = null;
  }
  async navigate(t) {
    const e = this._logger.create("navigate");
    if (!this._window)
      throw new Error("Attempted to navigate on a disposed window");
    e.debug("setting URL in window"), this._window.location.replace(t.url);
    const { url: s, keepOpen: i } = await new Promise((r, n) => {
      const o = (c) => {
        var l;
        const d = c.data, h = (l = t.scriptOrigin) != null ? l : window.location.origin;
        if (!(c.origin !== h || d?.source !== ie)) {
          try {
            const _ = F.readParams(d.url, t.response_mode).get("state");
            if (_ || e.warn("no state found in response url"), c.source !== this._window && _ !== t.state)
              return;
          } catch {
            this._dispose(), n(new Error("Invalid response from window"));
          }
          r(d);
        }
      };
      window.addEventListener("message", o, !1), this._disposeHandlers.add(() => window.removeEventListener("message", o, !1));
      const a = new BroadcastChannel(`oidc-client-popup-${t.state}`);
      a.addEventListener("message", o, !1), this._disposeHandlers.add(() => a.close()), this._disposeHandlers.add(this._abort.addHandler((c) => {
        this._dispose(), n(c);
      }));
    });
    return e.debug("got response from window"), this._dispose(), i || this.close(), { url: s };
  }
  _dispose() {
    this._logger.create("_dispose");
    for (const t of this._disposeHandlers)
      t();
    this._disposeHandlers.clear();
  }
  static _notifyParent(t, e, s = !1, i = window.location.origin) {
    const r = {
      source: ie,
      url: e,
      keepOpen: s
    }, n = new g("_notifyParent");
    if (t)
      n.debug("With parent. Using parent.postMessage."), t.postMessage(r, i);
    else {
      n.debug("No parent. Using BroadcastChannel.");
      const o = new URL(e).searchParams.get("state");
      if (!o)
        throw new Error("No parent and no state in URL. Can't complete notification.");
      const a = new BroadcastChannel(`oidc-client-popup-${o}`);
      a.postMessage(r), a.close();
    }
  }
}, fe = {
  location: !1,
  toolbar: !1,
  height: 640,
  closePopupWindowAfterInSeconds: -1
}, me = "_blank", st = 60, it = 2, Se = 10, rt = class extends B {
  constructor(t) {
    const {
      popup_redirect_uri: e = t.redirect_uri,
      popup_post_logout_redirect_uri: s = t.post_logout_redirect_uri,
      popupWindowFeatures: i = fe,
      popupWindowTarget: r = me,
      redirectMethod: n = "assign",
      redirectTarget: o = "self",
      iframeNotifyParentOrigin: a = t.iframeNotifyParentOrigin,
      iframeScriptOrigin: c = t.iframeScriptOrigin,
      requestTimeoutInSeconds: l,
      silent_redirect_uri: d = t.redirect_uri,
      silentRequestTimeoutInSeconds: h,
      automaticSilentRenew: _ = !0,
      validateSubOnSilentRenew: u = !0,
      includeIdTokenInSilentRenew: f = !1,
      monitorSession: v = !1,
      monitorAnonymousSession: x = !1,
      checkSessionIntervalInSeconds: A = it,
      query_status_response_type: P = "code",
      stopCheckSessionOnError: O = !0,
      revokeTokenTypes: U = ["access_token", "refresh_token"],
      revokeTokensOnSignout: y = !1,
      includeIdTokenInSilentSignout: w = !1,
      accessTokenExpiringNotificationTimeInSeconds: T = st,
      maxSilentRenewTimeoutRetries: R,
      userStore: m
    } = t;
    if (super(t), this.popup_redirect_uri = e, this.popup_post_logout_redirect_uri = s, this.popupWindowFeatures = i, this.popupWindowTarget = r, this.redirectMethod = n, this.redirectTarget = o, this.iframeNotifyParentOrigin = a, this.iframeScriptOrigin = c, this.silent_redirect_uri = d, this.silentRequestTimeoutInSeconds = h || l || Se, this.automaticSilentRenew = _, this.validateSubOnSilentRenew = u, this.includeIdTokenInSilentRenew = f, this.monitorSession = v, this.monitorAnonymousSession = x, this.checkSessionIntervalInSeconds = A, this.stopCheckSessionOnError = O, this.query_status_response_type = P, this.revokeTokenTypes = U, this.revokeTokensOnSignout = y, this.includeIdTokenInSilentSignout = w, this.accessTokenExpiringNotificationTimeInSeconds = T, this.maxSilentRenewTimeoutRetries = R, m)
      this.userStore = m;
    else {
      const q = typeof window < "u" ? window.sessionStorage : new ce();
      this.userStore = new le({ store: q });
    }
  }
}, re = class ve extends we {
  constructor({
    silentRequestTimeoutInSeconds: e = Se
  }) {
    super(), this._logger = new g("IFrameWindow"), this._timeoutInSeconds = e, this._frame = ve.createHiddenIframe(), this._window = this._frame.contentWindow;
  }
  static createHiddenIframe() {
    const e = window.document.createElement("iframe");
    return e.style.visibility = "hidden", e.style.position = "fixed", e.style.left = "-1000px", e.style.top = "0", e.width = "0", e.height = "0", window.document.body.appendChild(e), e;
  }
  async navigate(e) {
    this._logger.debug("navigate: Using timeout of:", this._timeoutInSeconds);
    const s = setTimeout(() => {
      this._abort.raise(new Q("IFrame timed out without a response"));
    }, this._timeoutInSeconds * 1e3);
    return this._disposeHandlers.add(() => clearTimeout(s)), await super.navigate(e);
  }
  close() {
    var e;
    this._frame && (this._frame.parentNode && (this._frame.addEventListener("load", (s) => {
      var i;
      const r = s.target;
      (i = r.parentNode) == null || i.removeChild(r), this._abort.raise(new Error("IFrame removed from DOM"));
    }, !0), (e = this._frame.contentWindow) == null || e.location.replace("about:blank")), this._frame = null), this._window = null;
  }
  static notifyParent(e, s) {
    return super._notifyParent(window.parent, e, !1, s);
  }
}, nt = class {
  constructor(t) {
    this._settings = t, this._logger = new g("IFrameNavigator");
  }
  async prepare({
    silentRequestTimeoutInSeconds: t = this._settings.silentRequestTimeoutInSeconds
  }) {
    return new re({ silentRequestTimeoutInSeconds: t });
  }
  async callback(t) {
    this._logger.create("callback"), re.notifyParent(t, this._settings.iframeNotifyParentOrigin);
  }
}, ot = 500, at = 1e3, ne = class extends we {
  constructor({
    popupWindowTarget: t = me,
    popupWindowFeatures: e = {},
    popupSignal: s,
    popupAbortOnClose: i
  }) {
    super(), this._logger = new g("PopupWindow");
    const r = se.center({ ...fe, ...e });
    this._window = window.open(void 0, t, se.serialize(r)), this.abortOnClose = !!i, s && s.addEventListener("abort", () => {
      var n;
      this._abort.raise(new Error((n = s.reason) != null ? n : "Popup aborted"));
    }), e.closePopupWindowAfterInSeconds && e.closePopupWindowAfterInSeconds > 0 && setTimeout(() => {
      if (!this._window || typeof this._window.closed != "boolean" || this._window.closed) {
        this._abort.raise(new Error("Popup blocked by user"));
        return;
      }
      this.close();
    }, e.closePopupWindowAfterInSeconds * at);
  }
  async navigate(t) {
    var e;
    (e = this._window) == null || e.focus();
    const s = setInterval(() => {
      (!this._window || this._window.closed) && (this._logger.debug("Popup closed by user or isolated by redirect"), i(), this._disposeHandlers.delete(i), this.abortOnClose && this._abort.raise(new Error("Popup closed by user")));
    }, ot), i = () => clearInterval(s);
    return this._disposeHandlers.add(i), await super.navigate(t);
  }
  close() {
    this._window && (this._window.closed || (this._window.close(), this._abort.raise(new Error("Popup closed")))), this._window = null;
  }
  static notifyOpener(t, e) {
    super._notifyParent(window.opener, t, e), !e && !window.opener && window.close();
  }
}, ct = class {
  constructor(t) {
    this._settings = t, this._logger = new g("PopupNavigator");
  }
  async prepare({
    popupWindowFeatures: t = this._settings.popupWindowFeatures,
    popupWindowTarget: e = this._settings.popupWindowTarget,
    popupSignal: s,
    popupAbortOnClose: i
  }) {
    return new ne({
      popupWindowFeatures: t,
      popupWindowTarget: e,
      popupSignal: s,
      popupAbortOnClose: i
    });
  }
  async callback(t, { keepOpen: e = !1 }) {
    this._logger.create("callback"), ne.notifyOpener(t, e);
  }
}, lt = class {
  constructor(t) {
    this._settings = t, this._logger = new g("RedirectNavigator");
  }
  async prepare({
    redirectMethod: t = this._settings.redirectMethod,
    redirectTarget: e = this._settings.redirectTarget
  }) {
    var s;
    this._logger.create("prepare");
    let i = window.self;
    e === "top" && (i = (s = window.top) != null ? s : window.self);
    const r = i.location[t].bind(i.location);
    let n;
    return {
      navigate: async (o) => (this._logger.create("navigate"), await new Promise((c, l) => {
        n = l, window.addEventListener("pageshow", () => c(window.location.href)), r(o.url);
      })),
      close: () => {
        this._logger.create("close"), n?.(new Error("Redirect aborted")), i.stop();
      }
    };
  }
  async callback() {
  }
}, dt = class extends je {
  constructor(t) {
    super({ expiringNotificationTimeInSeconds: t.accessTokenExpiringNotificationTimeInSeconds }), this._logger = new g("UserManagerEvents"), this._userLoaded = new C("User loaded"), this._userUnloaded = new C("User unloaded"), this._silentRenewError = new C("Silent renew error"), this._userSignedIn = new C("User signed in"), this._userSignedOut = new C("User signed out"), this._userSessionChanged = new C("User session changed");
  }
  async load(t, e = !0) {
    await super.load(t), e && await this._userLoaded.raise(t);
  }
  async unload() {
    await super.unload(), await this._userUnloaded.raise();
  }
  /**
   * Add callback: Raised when a user session has been established (or re-established).
   */
  addUserLoaded(t) {
    return this._userLoaded.addHandler(t);
  }
  /**
   * Remove callback: Raised when a user session has been established (or re-established).
   */
  removeUserLoaded(t) {
    return this._userLoaded.removeHandler(t);
  }
  /**
   * Add callback: Raised when a user session has been terminated.
   */
  addUserUnloaded(t) {
    return this._userUnloaded.addHandler(t);
  }
  /**
   * Remove callback: Raised when a user session has been terminated.
   */
  removeUserUnloaded(t) {
    return this._userUnloaded.removeHandler(t);
  }
  /**
   * Add callback: Raised when the automatic silent renew has failed.
   */
  addSilentRenewError(t) {
    return this._silentRenewError.addHandler(t);
  }
  /**
   * Remove callback: Raised when the automatic silent renew has failed.
   */
  removeSilentRenewError(t) {
    return this._silentRenewError.removeHandler(t);
  }
  /**
   * @internal
   */
  async _raiseSilentRenewError(t) {
    await this._silentRenewError.raise(t);
  }
  /**
   * Add callback: Raised when the user is signed in (when `monitorSession` is set).
   * @see {@link UserManagerSettings.monitorSession}
   */
  addUserSignedIn(t) {
    return this._userSignedIn.addHandler(t);
  }
  /**
   * Remove callback: Raised when the user is signed in (when `monitorSession` is set).
   */
  removeUserSignedIn(t) {
    this._userSignedIn.removeHandler(t);
  }
  /**
   * @internal
   */
  async _raiseUserSignedIn() {
    await this._userSignedIn.raise();
  }
  /**
   * Add callback: Raised when the user's sign-in status at the OP has changed (when `monitorSession` is set).
   * @see {@link UserManagerSettings.monitorSession}
   */
  addUserSignedOut(t) {
    return this._userSignedOut.addHandler(t);
  }
  /**
   * Remove callback: Raised when the user's sign-in status at the OP has changed (when `monitorSession` is set).
   */
  removeUserSignedOut(t) {
    this._userSignedOut.removeHandler(t);
  }
  /**
   * @internal
   */
  async _raiseUserSignedOut() {
    await this._userSignedOut.raise();
  }
  /**
   * Add callback: Raised when the user session changed (when `monitorSession` is set).
   * @see {@link UserManagerSettings.monitorSession}
   */
  addUserSessionChanged(t) {
    return this._userSessionChanged.addHandler(t);
  }
  /**
   * Remove callback: Raised when the user session changed (when `monitorSession` is set).
   */
  removeUserSessionChanged(t) {
    this._userSessionChanged.removeHandler(t);
  }
  /**
   * @internal
   */
  async _raiseUserSessionChanged() {
    await this._userSessionChanged.raise();
  }
}, ht = class {
  constructor(t) {
    this._userManager = t, this._logger = new g("SilentRenewService"), this._isStarted = !1, this._retryTimer = new I("Retry Silent Renew"), this._timeoutRetryCount = 0, this._tokenExpiring = async () => {
      const e = this._logger.create("_tokenExpiring");
      try {
        await this._userManager.signinSilent(), this._timeoutRetryCount = 0, e.debug("silent token renewal successful");
      } catch (s) {
        if (s instanceof Q) {
          this._timeoutRetryCount++;
          const i = this._userManager.settings.maxSilentRenewTimeoutRetries;
          if (i !== void 0 && this._timeoutRetryCount > i) {
            e.error(
              `Timeout retry limit reached (${this._timeoutRetryCount} > ${i}), raising silentRenewError:`,
              s
            ), this._timeoutRetryCount = 0, await this._userManager.events._raiseSilentRenewError(s);
            return;
          }
          e.warn(
            `ErrorTimeout from signinSilent (attempt ${this._timeoutRetryCount}), retry in 5s:`,
            s
          ), this._retryTimer.init(5);
          return;
        }
        e.error("Error from signinSilent:", s), this._timeoutRetryCount = 0, await this._userManager.events._raiseSilentRenewError(s);
      }
    };
  }
  async start() {
    const t = this._logger.create("start");
    if (!this._isStarted) {
      this._isStarted = !0, this._userManager.events.addAccessTokenExpiring(this._tokenExpiring), this._retryTimer.addHandler(this._tokenExpiring);
      try {
        await this._userManager.getUser();
      } catch (e) {
        t.error("getUser error", e);
      }
    }
  }
  stop() {
    this._isStarted && (this._retryTimer.cancel(), this._retryTimer.removeHandler(this._tokenExpiring), this._userManager.events.removeAccessTokenExpiring(this._tokenExpiring), this._isStarted = !1);
  }
}, gt = class {
  constructor(t) {
    this.refresh_token = t.refresh_token, this.id_token = t.id_token, this.session_state = t.session_state, this.scope = t.scope, this.profile = t.profile, this.data = t.state;
  }
}, oe = class {
  constructor(t, e, s, i) {
    this._logger = new g("UserManager"), this.settings = new rt(t), this._client = new et(t), this._redirectNavigator = e ?? new lt(this.settings), this._popupNavigator = s ?? new ct(this.settings), this._iframeNavigator = i ?? new nt(this.settings), this._events = new dt(this.settings), this._silentRenewService = new ht(this), this.settings.automaticSilentRenew && this.startSilentRenew(), this._sessionMonitor = null, this.settings.monitorSession && (this._sessionMonitor = new tt(this));
  }
  /**
   * Get object used to register for events raised by the `UserManager`.
   */
  get events() {
    return this._events;
  }
  /**
   * Get object used to access the metadata configuration of the identity provider.
   */
  get metadataService() {
    return this._client.metadataService;
  }
  /**
   * Load the `User` object for the currently authenticated user.
   *
   * @param raiseEvent - If `true`, the `UserLoaded` event will be raised. Defaults to false.
   * @returns A promise
   */
  async getUser(t = !1) {
    const e = this._logger.create("getUser"), s = await this._loadUser();
    return s ? (e.info("user loaded"), await this._events.load(s, t), s) : (e.info("user not found in storage"), null);
  }
  /**
   * Remove from any storage the currently authenticated user.
   *
   * @returns A promise
   */
  async removeUser() {
    const t = this._logger.create("removeUser");
    await this.storeUser(null), t.info("user removed from storage"), await this._events.unload();
  }
  /**
   * Trigger a redirect of the current window to the authorization endpoint.
   *
   * @returns A promise
   *
   * @throws `Error` In cases of wrong authentication.
   */
  async signinRedirect(t = {}) {
    var e;
    this._logger.create("signinRedirect");
    const {
      redirectMethod: s,
      ...i
    } = t;
    let r;
    (e = this.settings.dpop) != null && e.bind_authorization_code && (r = await this.generateDPoPJkt(this.settings.dpop));
    const n = await this._redirectNavigator.prepare({ redirectMethod: s });
    await this._signinStart({
      request_type: "si:r",
      dpopJkt: r,
      ...i
    }, n);
  }
  /**
   * Process the response (callback) from the authorization endpoint.
   * It is recommended to use {@link UserManager.signinCallback} instead.
   *
   * @returns A promise containing the authenticated `User`.
   *
   * @see {@link UserManager.signinCallback}
   */
  async signinRedirectCallback(t = window.location.href) {
    const e = this._logger.create("signinRedirectCallback"), s = await this._signinEnd(t);
    return s.profile && s.profile.sub ? e.info("success, signed in subject", s.profile.sub) : e.info("no subject"), s;
  }
  /**
   * Trigger the signin with user/password.
   *
   * @returns A promise containing the authenticated `User`.
   * @throws {@link ErrorResponse} In cases of wrong authentication.
   */
  async signinResourceOwnerCredentials({
    username: t,
    password: e,
    skipUserInfo: s = !1
  }) {
    const i = this._logger.create("signinResourceOwnerCredential"), r = await this._client.processResourceOwnerPasswordCredentials({
      username: t,
      password: e,
      skipUserInfo: s,
      extraTokenParams: this.settings.extraTokenParams
    });
    i.debug("got signin response");
    const n = await this._buildUser(r);
    return n.profile && n.profile.sub ? i.info("success, signed in subject", n.profile.sub) : i.info("no subject"), n;
  }
  /**
   * Trigger a request (via a popup window) to the authorization endpoint.
   *
   * @returns A promise containing the authenticated `User`.
   * @throws `Error` In cases of wrong authentication.
   */
  async signinPopup(t = {}) {
    var e;
    const s = this._logger.create("signinPopup");
    let i;
    (e = this.settings.dpop) != null && e.bind_authorization_code && (i = await this.generateDPoPJkt(this.settings.dpop));
    const {
      popupWindowFeatures: r,
      popupWindowTarget: n,
      popupSignal: o,
      popupAbortOnClose: a,
      ...c
    } = t, l = this.settings.popup_redirect_uri;
    l || s.throw(new Error("No popup_redirect_uri configured"));
    const d = await this._popupNavigator.prepare({ popupWindowFeatures: r, popupWindowTarget: n, popupSignal: o, popupAbortOnClose: a }), h = await this._signin({
      request_type: "si:p",
      redirect_uri: l,
      display: "popup",
      dpopJkt: i,
      ...c
    }, d);
    return h && (h.profile && h.profile.sub ? s.info("success, signed in subject", h.profile.sub) : s.info("no subject")), h;
  }
  /**
   * Notify the opening window of response (callback) from the authorization endpoint.
   * It is recommended to use {@link UserManager.signinCallback} instead.
   *
   * @returns A promise
   *
   * @see {@link UserManager.signinCallback}
   */
  async signinPopupCallback(t = window.location.href, e = !1) {
    const s = this._logger.create("signinPopupCallback");
    await this._popupNavigator.callback(t, { keepOpen: e }), s.info("success");
  }
  /**
   * Trigger a silent request (via refresh token or an iframe) to the authorization endpoint.
   *
   * @returns A promise that contains the authenticated `User`.
   */
  async signinSilent(t = {}) {
    var e, s;
    const i = this._logger.create("signinSilent"), {
      silentRequestTimeoutInSeconds: r,
      ...n
    } = t;
    let o = await this._loadUser();
    if (!t.forceIframeAuth && o?.refresh_token) {
      i.debug("using refresh token");
      const h = new gt(o);
      return await this._useRefreshToken({
        state: h,
        redirect_uri: n.redirect_uri,
        resource: n.resource,
        extraTokenParams: n.extraTokenParams,
        timeoutInSeconds: r
      });
    }
    let a;
    (e = this.settings.dpop) != null && e.bind_authorization_code && (a = await this.generateDPoPJkt(this.settings.dpop));
    const c = this.settings.silent_redirect_uri;
    c || i.throw(new Error("No silent_redirect_uri configured"));
    let l;
    o && this.settings.validateSubOnSilentRenew && (i.debug("subject prior to silent renew:", o.profile.sub), l = o.profile.sub);
    const d = await this._iframeNavigator.prepare({ silentRequestTimeoutInSeconds: r });
    return o = await this._signin({
      request_type: "si:s",
      redirect_uri: c,
      prompt: "none",
      id_token_hint: this.settings.includeIdTokenInSilentRenew ? o?.id_token : void 0,
      dpopJkt: a,
      ...n
    }, d, l), o && ((s = o.profile) != null && s.sub ? i.info("success, signed in subject", o.profile.sub) : i.info("no subject")), o;
  }
  async _useRefreshToken(t) {
    const e = await this._client.useRefreshToken({
      timeoutInSeconds: this.settings.silentRequestTimeoutInSeconds,
      ...t
    }), s = new D({ ...t.state, ...e });
    return await this.storeUser(s), await this._events.load(s), s;
  }
  /**
   *
   * Notify the parent window of response (callback) from the authorization endpoint.
   * It is recommended to use {@link UserManager.signinCallback} instead.
   *
   * @returns A promise
   *
   * @see {@link UserManager.signinCallback}
   */
  async signinSilentCallback(t = window.location.href) {
    const e = this._logger.create("signinSilentCallback");
    await this._iframeNavigator.callback(t), e.info("success");
  }
  /**
   * Process any response (callback) from the authorization endpoint, by dispatching the request_type
   * and executing one of the following functions:
   * - {@link UserManager.signinRedirectCallback}
   * - {@link UserManager.signinPopupCallback}
   * - {@link UserManager.signinSilentCallback}
   *
   * @throws `Error` If request_type is unknown or signin cannot be processed.
   */
  async signinCallback(t = window.location.href) {
    const { state: e } = await this._client.readSigninResponseState(t);
    switch (e.request_type) {
      case "si:r":
        return await this.signinRedirectCallback(t);
      case "si:p":
        await this.signinPopupCallback(t);
        break;
      case "si:s":
        await this.signinSilentCallback(t);
        break;
      default:
        throw new Error("invalid request_type in state");
    }
  }
  /**
   * Process any response (callback) from the end session endpoint, by dispatching the request_type
   * and executing one of the following functions:
   * - {@link UserManager.signoutRedirectCallback}
   * - {@link UserManager.signoutPopupCallback}
   * - {@link UserManager.signoutSilentCallback}
   *
   * @throws `Error` If request_type is unknown or signout cannot be processed.
   */
  async signoutCallback(t = window.location.href, e = !1) {
    const { state: s } = await this._client.readSignoutResponseState(t);
    if (s)
      switch (s.request_type) {
        case "so:r":
          return await this.signoutRedirectCallback(t);
        case "so:p":
          await this.signoutPopupCallback(t, e);
          break;
        case "so:s":
          await this.signoutSilentCallback(t);
          break;
        default:
          throw new Error("invalid request_type in state");
      }
  }
  /**
   * Query OP for user's current signin status.
   *
   * @returns A promise object with session_state and subject identifier.
   */
  async querySessionStatus(t = {}) {
    const e = this._logger.create("querySessionStatus"), {
      silentRequestTimeoutInSeconds: s,
      ...i
    } = t, r = this.settings.silent_redirect_uri;
    r || e.throw(new Error("No silent_redirect_uri configured"));
    const n = await this._loadUser(), o = await this._iframeNavigator.prepare({ silentRequestTimeoutInSeconds: s }), a = await this._signinStart({
      request_type: "si:s",
      // this acts like a signin silent
      redirect_uri: r,
      prompt: "none",
      id_token_hint: this.settings.includeIdTokenInSilentRenew ? n?.id_token : void 0,
      response_type: this.settings.query_status_response_type,
      scope: "openid",
      skipUserInfo: !0,
      ...i
    }, o);
    try {
      const c = {}, l = await this._client.processSigninResponse(a.url, c);
      return e.debug("got signin response"), l.session_state && l.profile.sub ? (e.info("success for subject", l.profile.sub), {
        session_state: l.session_state,
        sub: l.profile.sub
      }) : (e.info("success, user not authenticated"), null);
    } catch (c) {
      if (this.settings.monitorAnonymousSession && c instanceof M)
        switch (c.error) {
          case "login_required":
          case "consent_required":
          case "interaction_required":
          case "account_selection_required":
            return e.info("success for anonymous user"), {
              session_state: c.session_state
            };
        }
      throw c;
    }
  }
  async _signin(t, e, s) {
    const i = await this._signinStart(t, e);
    return await this._signinEnd(i.url, s);
  }
  async _signinStart(t, e) {
    const s = this._logger.create("_signinStart");
    try {
      const i = await this._client.createSigninRequest(t);
      return s.debug("got signin request"), await e.navigate({
        url: i.url,
        state: i.state.id,
        response_mode: i.state.response_mode,
        scriptOrigin: this.settings.iframeScriptOrigin
      });
    } catch (i) {
      throw s.debug("error after preparing navigator, closing navigator window"), e.close(), i;
    }
  }
  async _signinEnd(t, e) {
    const s = this._logger.create("_signinEnd"), i = {}, r = await this._client.processSigninResponse(t, i);
    return s.debug("got signin response"), await this._buildUser(r, e);
  }
  async _buildUser(t, e) {
    const s = this._logger.create("_buildUser"), i = new D(t);
    if (e) {
      if (e !== i.profile.sub)
        throw s.debug("current user does not match user returned from signin. sub from signin:", i.profile.sub), new M({ ...t, error: "login_required" });
      s.debug("current user matches user returned from signin");
    }
    return await this.storeUser(i), s.debug("user stored"), await this._events.load(i), i;
  }
  /**
   * Trigger a redirect of the current window to the end session endpoint.
   *
   * @returns A promise
   */
  async signoutRedirect(t = {}) {
    const e = this._logger.create("signoutRedirect"), {
      redirectMethod: s,
      ...i
    } = t, r = await this._redirectNavigator.prepare({ redirectMethod: s });
    await this._signoutStart({
      request_type: "so:r",
      post_logout_redirect_uri: this.settings.post_logout_redirect_uri,
      ...i
    }, r), e.info("success");
  }
  /**
   * Process response (callback) from the end session endpoint.
   * It is recommended to use {@link UserManager.signoutCallback} instead.
   *
   * @returns A promise containing signout response
   *
   * @see {@link UserManager.signoutCallback}
   */
  async signoutRedirectCallback(t = window.location.href) {
    const e = this._logger.create("signoutRedirectCallback"), s = await this._signoutEnd(t);
    return e.info("success"), s;
  }
  /**
   * Trigger a redirect of a popup window to the end session endpoint.
   *
   * @returns A promise
   */
  async signoutPopup(t = {}) {
    const e = this._logger.create("signoutPopup"), {
      popupWindowFeatures: s,
      popupWindowTarget: i,
      popupSignal: r,
      ...n
    } = t, o = this.settings.popup_post_logout_redirect_uri, a = await this._popupNavigator.prepare({ popupWindowFeatures: s, popupWindowTarget: i, popupSignal: r });
    await this._signout({
      request_type: "so:p",
      post_logout_redirect_uri: o,
      // we're putting a dummy entry in here because we
      // need a unique id from the state for notification
      // to the parent window, which is necessary if we
      // plan to return back to the client after signout
      // and so we can close the popup after signout
      state: o == null ? void 0 : {},
      ...n
    }, a), e.info("success");
  }
  /**
   * Process response (callback) from the end session endpoint from a popup window.
   * It is recommended to use {@link UserManager.signoutCallback} instead.
   *
   * @returns A promise
   *
   * @see {@link UserManager.signoutCallback}
   */
  async signoutPopupCallback(t = window.location.href, e = !1) {
    const s = this._logger.create("signoutPopupCallback");
    await this._popupNavigator.callback(t, { keepOpen: e }), s.info("success");
  }
  async _signout(t, e) {
    const s = await this._signoutStart(t, e);
    return await this._signoutEnd(s.url);
  }
  async _signoutStart(t = {}, e) {
    var s;
    const i = this._logger.create("_signoutStart");
    try {
      const r = await this._loadUser();
      i.debug("loaded current user from storage"), this.settings.revokeTokensOnSignout && await this._revokeInternal(r);
      const n = t.id_token_hint || r && r.id_token;
      n && (i.debug("setting id_token_hint in signout request"), t.id_token_hint = n), await this.removeUser(), i.debug("user removed, creating signout request");
      const o = await this._client.createSignoutRequest(t);
      return i.debug("got signout request"), await e.navigate({
        url: o.url,
        state: (s = o.state) == null ? void 0 : s.id,
        scriptOrigin: this.settings.iframeScriptOrigin
      });
    } catch (r) {
      throw i.debug("error after preparing navigator, closing navigator window"), e.close(), r;
    }
  }
  async _signoutEnd(t) {
    const e = this._logger.create("_signoutEnd"), s = await this._client.processSignoutResponse(t);
    return e.debug("got signout response"), s;
  }
  /**
   * Trigger a silent request (via an iframe) to the end session endpoint.
   *
   * @returns A promise
   */
  async signoutSilent(t = {}) {
    var e;
    const s = this._logger.create("signoutSilent"), {
      silentRequestTimeoutInSeconds: i,
      ...r
    } = t, n = this.settings.includeIdTokenInSilentSignout ? (e = await this._loadUser()) == null ? void 0 : e.id_token : void 0, o = this.settings.popup_post_logout_redirect_uri, a = await this._iframeNavigator.prepare({ silentRequestTimeoutInSeconds: i });
    await this._signout({
      request_type: "so:s",
      post_logout_redirect_uri: o,
      id_token_hint: n,
      ...r
    }, a), s.info("success");
  }
  /**
   * Notify the parent window of response (callback) from the end session endpoint.
   * It is recommended to use {@link UserManager.signoutCallback} instead.
   *
   * @returns A promise
   *
   * @see {@link UserManager.signoutCallback}
   */
  async signoutSilentCallback(t = window.location.href) {
    const e = this._logger.create("signoutSilentCallback");
    await this._iframeNavigator.callback(t), e.info("success");
  }
  async revokeTokens(t) {
    const e = await this._loadUser();
    await this._revokeInternal(e, t);
  }
  async _revokeInternal(t, e = this.settings.revokeTokenTypes) {
    const s = this._logger.create("_revokeInternal");
    if (!t) return;
    const i = e.filter((r) => typeof t[r] == "string");
    if (!i.length) {
      s.debug("no need to revoke due to no token(s)");
      return;
    }
    for (const r of i)
      await this._client.revokeToken(
        t[r],
        r
      ), s.info(`${r} revoked successfully`), r !== "access_token" && (t[r] = null);
    await this.storeUser(t), s.debug("user stored"), await this._events.load(t);
  }
  /**
   * Enables silent renew for the `UserManager`.
   */
  startSilentRenew() {
    this._logger.create("startSilentRenew"), this._silentRenewService.start();
  }
  /**
   * Disables silent renew for the `UserManager`.
   */
  stopSilentRenew() {
    this._silentRenewService.stop();
  }
  get _userStoreKey() {
    return `user:${this.settings.authority}:${this.settings.client_id}`;
  }
  async _loadUser() {
    const t = this._logger.create("_loadUser"), e = await this.settings.userStore.get(this._userStoreKey);
    return e ? (t.debug("user storageString loaded"), D.fromStorageString(e)) : (t.debug("no user storageString"), null);
  }
  async storeUser(t) {
    const e = this._logger.create("storeUser");
    if (t) {
      e.debug("storing user");
      const s = t.toStorageString();
      await this.settings.userStore.set(this._userStoreKey, s);
    } else
      this._logger.debug("removing user"), await this.settings.userStore.remove(this._userStoreKey), this.settings.dpop && await this.settings.dpop.store.remove(this.settings.client_id);
  }
  /**
   * Removes stale state entries in storage for incomplete authorize requests.
   */
  async clearStaleState() {
    await this._client.clearStaleState();
  }
  /**
   * Dynamically generates a DPoP proof for a given user, URL and optional Http method.
   * This method is useful when you need to make a request to a resource server
   * with fetch or similar, and you need to include a DPoP proof in a DPoP header.
   * @param url - The URL to generate the DPoP proof for
   * @param user - The user to generate the DPoP proof for
   * @param httpMethod - Optional, defaults to "GET"
   * @param nonce - Optional nonce provided by the resource server
   *
   * @returns A promise containing the DPoP proof or undefined if DPoP is not enabled/no user is found.
   */
  async dpopProof(t, e, s, i) {
    var r, n;
    const o = await ((n = (r = this.settings.dpop) == null ? void 0 : r.store) == null ? void 0 : n.get(this.settings.client_id));
    if (o)
      return await p.generateDPoPProof({
        url: t,
        accessToken: e?.access_token,
        httpMethod: s,
        keyPair: o.keys,
        nonce: i
      });
  }
  async generateDPoPJkt(t) {
    let e = await t.store.get(this.settings.client_id);
    if (!e) {
      const s = await p.generateDPoPKeys();
      e = new _e(s), await t.store.set(this.settings.client_id, e);
    }
    return await p.generateDPoPJkt(e.keys);
  }
};
const ut = ({
  loginRoutePath: t,
  redirectSearchParamName: e,
  searchParamsToPersist: s,
  onNavigate: i
}) => (r) => {
  const n = xe(), [o, a] = ee(!1), [c, l] = ee(
    r?.tryAutoSignIn || !1
  );
  return te(() => {
    async function d() {
      r?.tryAutoSignIn && !Ae() && !n.isAuthenticated && !n.activeNavigator && !n.isLoading && !o && !n.error && (await n.signinRedirect({
        redirect_uri: window.location.href
      }), a(!0));
    }
    d().then(() => {
      l(!1);
    });
  }, [n, o, r?.tryAutoSignIn]), te(() => {
    n.error && r?.redirectToLoginOnError && i(
      ye({
        loginRoutePath: r?.loginRoutePath || t,
        redirectSearchParamName: r?.redirectSearchParamName || e,
        searchParamsToPersist: s
      })
    );
  }, [
    n.error,
    r?.loginRoutePath,
    r?.redirectSearchParamName,
    r?.redirectToLoginOnError
  ]), {
    ...n,
    isLoading: n.isLoading || c
  };
}, ye = ({
  loginRoutePath: t,
  redirectSearchParamName: e,
  searchParamsToPersist: s = []
}) => {
  const i = new URLSearchParams(window.location.search), r = new URLSearchParams();
  r.set(
    e,
    window.location.pathname + window.location.search
  ), s.forEach((o) => {
    i.has(o) && r.set(o, i.get(o));
  });
  const n = new URL(window.location.origin + t);
  return n.search = r.toString(), n;
}, ft = () => {
  const t = new URL(window.location.href), e = new URLSearchParams(t.search);
  if (e.delete("code"), e.delete("iss"), e.delete("session_state"), e.delete("state"), !e.size) {
    window.history.replaceState({}, "", t.pathname);
    return;
  }
  window.history.replaceState({}, "", `${t.pathname}?${e}`);
}, mt = (t, {
  loginRoutePath: e,
  redirectSearchParamName: s = "redirect",
  searchParamsToPersist: i = [],
  onNavigate: r = (n) => {
    window.location.href = n.toString();
  }
}) => {
  let n = new oe(t);
  const o = () => n, a = (u) => (n = new oe(u), n), c = () => {
    const u = o(), f = localStorage.getItem(
      `oidc.user:${u.settings.authority}:${u.settings.client_id}`
    );
    return f ? D.fromStorageString(f) : null;
  }, l = () => `Bearer ${c()?.access_token}`, d = () => {
    r(
      ye({
        loginRoutePath: e,
        redirectSearchParamName: s,
        searchParamsToPersist: i
      })
    );
  }, h = async ({
    config: u
  }) => {
    const f = o(), v = await f.getUser();
    if (v?.expired) {
      try {
        await f.signinSilent();
      } catch {
        await f.removeUser().catch(() => {
        }), d();
        return;
      }
      return await Ce.request({
        ...u,
        headers: {
          ...u.headers,
          Authorization: l()
        }
      });
    }
    v || d();
  };
  return {
    axiosAuthInterceptor: [
      /* eslint-enable @typescript-eslint/no-explicit-any */
      async (u) => u?.data?.errors?.[0]?.extensions?.code === "UNAUTHENTICATED" && await h({ config: u.config }) || u,
      async (u) => {
        throw u.response?.status === 401 && await h({ config: u.config }), u;
      }
    ],
    getUserFromStorage: c,
    getAuthorizationHeader: l,
    get userManager() {
      return o();
    },
    useAuth: ut({
      loginRoutePath: e,
      redirectSearchParamName: s,
      searchParamsToPersist: i,
      onNavigate: r
    }),
    updateUserManager: a
  };
};
export {
  mt as c,
  ye as g,
  ut as m,
  ft as r
};
